module.exports = __webpack_public_path__ + "static/media/sidebar-0.4bcc1378.jpg";